const TEMP_VIEWS_CONFIG_CHANGE = 'TEMP_VIEWS_CONFIG/CHANGE';

export default function tempViewsConfigurationChangeAction (data: { [key: string]: any }) {
  return {
    type: TEMP_VIEWS_CONFIG_CHANGE,
    payload: {
        data: data
     }
  };
}

export { TEMP_VIEWS_CONFIG_CHANGE };